<template>
  <b-card class="w-100">
    <b-tabs pills class="w-100">
      <b-tab title="participants">
        <hr class="w-100" />
        <participants-table />
      </b-tab>
      <b-tab
        title="open trades"
        v-if="userData && Object.keys(userData).length && competition.active"
      >
        <hr class="w-100" />
        <open-trades />
      </b-tab>
      <b-tab title="Rules">
        <hr class="w-100" />
        <b-card>
          <div
            class="font-wegiht-bold mb-2 px-1"
            v-if="competition.draw_down_value != null"
          >
            <span class="text-bold">1 ) Drawdown percentage: </span
            ><span class="text-success">
              {{
                competition.draw_down_value
                  ? parseFloat(Number(competition.draw_down_value)) + "%"
                  : "0"
              }}</span
            >
          </div>
          <div
            class="font-wegiht-bold mb-2 px-1"
            v-if="competition.starting_balance_value != null"
          >
            <span class="text-bold">2 ) Starting balance: </span
            ><span class="text-success">
              {{
                competition.starting_balance_value
                  ? "$" + competition.starting_balance_value
                  : "0"
              }}</span
            >
          </div>
          <div
            class="font-wegiht-bold mb-2 px-1"
            v-if="competition.minimum_trade_value != null"
          >
            <span class="text-bold">3 ) Minimum number of trades: </span>

            <span class="text-success">
              {{
                competition.minimum_trade_value
                  ? competition.minimum_trade_value
                  : "0"
              }}</span
            >
          </div>
        </b-card>
      </b-tab>
      <b-tab title="Terms and conditions">
        <hr class="w-100" />
        <b-card>
          <template
            v-if="
              hasOwnNestedProperty(competition, 'conditions.length') &&
              competition.conditions.length
            "
          >
            <div
              class="font-wegiht-bold mb-2 px-1"
              v-for="(condition, index) in competition.conditions"
              :key="index"
            >
              {{ index + 1 + ". " + condition || "-" }}
            </div>
          </template>
          <template v-else>
            <div
              class="d-flex align-items-center justify-content-center h-100 new-alert"
            >
              <b-alert
                show
                variant="secondary"
                class="d-flex align-items-center justify-content-center p-3 w-100"
              >
                no information
              </b-alert>
            </div>
          </template>
        </b-card>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BTabs, BTab, BCard, BAlert } from "bootstrap-vue";
import ParticipantsTable from "@/views/panel/competitions/competition-live/ParticipantsTable.vue";
import OpenTrades from "@/views/panel/competitions/competition-live/OpenTrades.vue";

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    ParticipantsTable,
    OpenTrades,
    BAlert,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
};
</script>
<style>
[dir] .dark-layout .nav-pills .nav-item .nav-link.active {
  background: linear-gradient(
    119deg,
    rgb(251, 173, 37) 0%,
    rgb(250, 75, 104) 100%
  ) !important;
}
[dir] .nav-pills .nav-link.active {
  border: none;
  box-shadow: none;
}
</style>
